import DiscountAmount from './discount-amount-view'

export default DiscountAmount
